export default {
	// header Menu
	user_menu_kccIntro: 'KCC Intro',
	user_menu_product: 'Product',
	user_menu_market: 'Market',
	user_menu_productSupport: 'Product Support',
	user_menu_customerSupport: 'Customer Support',

	user_marketMain: 'Market Main',
	user_functionMain: 'Function Main',

	// KCC소개
	user_common_kccIntro : 'KCC Introduction',
	user_common_kccIntro_kccam : 'KCC Advanced Materials',
	user_common_kccIntro_globalNetwork : 'Global Network',
	user_common_kccIntro_newsRoom : 'Newsroom',
	user_common_next : 'Next',
	user_common_complete : 'Complete',

	user_common_View : 'View',
	user_common_By: 'By',
	user_common_store: 'Store',
	user_common_RelatedApplication: 'Related Application',

	// product 정보
	user_common_product : 'Product',
	user_common_product_application_etc : 'Etc',
	user_common_product_mouseover_txt : 'More',

	user_product_guide_tit : 'KTMC series selection guide(LSI devices)',
	user_product_guide_Package : 'Package',
	user_product_guide_Product : 'Product ',
	user_product_guide_Features : 'Features',
	user_product_guide_Type : 'Type',
	user_product_guide_Devices : 'Devices',
	user_product_guide_LSI : 'LSI',

	user_product_LeadFrame : 'Lead Frame',
	user_product_Substract : 'Substrate',
	user_product_Description : 'Description',
	user_product_introduction_tit : 'KCC EMC INTRODUCTION(Power Module FP)',
	user_product_introduction : 'INTRODUCTION',

	user_product_TestItem : 'TEST ITEM',
	user_product_Unit : 'Unit',
	user_product_Typical : 'Typical',
	user_product_TestMethod : 'Test Method',
	user_product_Value : 'Value',

	//datasheet modal
	user_datasheetModal_showList : 'View full list',
	user_datasheetModal_swalWithOptions_tit : 'Check for modifications',
	user_datasheetModal_swalWithOptions_contents : 'Please check more than one row',

	// Technical DataSheet
	user_common_product_technicalDataSheet : 'Technical DataSheet',

	// product dataSheet 제목
	user_common_product_productDataSheet : 'Product Datasheet',

	// datasheet 하단 버튼
	user_common_product_dataSheet_compareBtn : 'compare products',

	// Similar Product
	user_common_product_similarProduct : 'Similary Product',
	user_common_product_similarProduct_no : 'No.',
	user_common_product_similarProduct_series : 'Series',
	user_common_product_similarProduct_name : 'Name',
	user_common_product_similarProduct_summary : 'Summary',

	user_common_product_ViewSummary : 'View Summary',

	// classification 관련 내용
	user_common_productClassification : 'Product Classification',
	user_common_application : 'Application',
	user_common_detail_application : 'Detail Application',

	//# markets
	user_common_market : 'Market',

	// function
	user_common_function : 'Function',

	// page footer
	user_common_footer_address : '344, Sapyeong-daero, Seocho-gu, Seoul | Customer Service Office 080-022 - 8200, Representative Number 02 - 3480 - 5000',
	user_common_footer_copyright : 'COPYRIGHT (C) 2017 KCC CORPORATION ALL RIGHTS RESERVED',

	user_common_footer_lang : 'Language',
	user_common_footer_repreNumber : 'Representative number',
	user_common_footer_familySite : 'Family Site',
	user_common_footer_familySite_subTxt1 : "KCC's family site.",
	user_common_footer_familySite_subTxt2 : 'If you select an affiliate below, you will go to the website.',
	user_common_footer_familySite_kccCorporation : 'KCC Corporation',
	user_common_footer_familySite_facebook : 'KCC Official Facebook',
	user_common_footer_familySite_blog : 'KCC Official Blog',
	user_common_footer_familySite_automobileMt : 'KCC Automobile Maintenance Fees',
	user_common_footer_familySite_shipPaint : 'KCC ship paint',
	user_common_footer_familySite_basketballTeam : 'KCC Egis Professional Basketball Team',
	user_common_footer_familySite_colorDesign : 'KCC Color & Design Center',
	user_common_footer_familySite_glass : 'KCC GLASS',
	user_common_footer_familySite_homecc : 'HOME CC',
	user_common_footer_familySite_construction : 'KCC Construction',
	user_common_footer_familySite_kccsilicone : 'KCC SILICONE',
	user_common_footer_familySite_genmgang : 'GENMGANG LEISURE',
	user_common_footer_familySite_basildon : 'BASILDON',
	user_common_footer_policyPrivacy : 'Personal Information Processing Policy',

	// Main페이지
	// popup
	user_main_popup_header : 'New Product is launched',
	user_main_popup_footer : "Don't pop up for a week",
	user_main_popup_close : 'Close',

	user_main_youtube_tit : 'The ADVANCED MATERIALS OF KCC',
	user_main_youtube_play : 'play',


	// 헤더
	user_main_slider_header1_tit : 'EMC Organic Material',
	user_main_slider_header1_subtxt : 'Electromagnetic Compatibility',

	user_main_slider_header2_tit : 'EMI Radiation',
	user_main_slider_header2_subtxt : 'Electromagnetic Interference',

	user_main_slider_header3_tit : 'EMS Sensivity',
	user_main_slider_header3_subtxt : 'Electromagnetic Susceptibility',

	user_main_globalNetwork : 'Detail for GlobalNetwork',

	// KCC 소개 페이지
	// 헤더
	user_intro_introKcc_header_tit : 'KCC Introduction',
	user_intro_introAM_header_tit : 'KCC AM',
	user_intro_introKcc_header_subtxt : 'Details of KCC introduction.',
	user_intro_introAM_header_subtxt : 'KCC AM introduction',
	user_intro_introAM_body_tit : 'The coordinates of the future industry, finding in KCC advanced materials',
	user_intro_introAM_body_subtxt1 : 'KCC\'s advanced materials are classified into <strong>organic materials, inorganic materials, and composite materials</strong><br/>, and are supplied to various industries for each material.',


	user_intro_introAM_body_content1_tit : 'Organic material',
	user_intro_introAM_body_content1_subtxt : 'KCC organic materials include semiconductor encapsulants (EMC) and electrical and electronic adhesives.\n'
											+'KCC organic materials are used in most products where semiconductors are used, including general home appliances such as mobile phones, refrigerators, and TVs, industrial equipment, and automobiles.\n'
											+'As the number of products reflecting advanced IT technology increases, the global semiconductor market is expanding, and the demand for KCC organic materials is also increasing.\n\n'
											+'Semiconductor materials include various adhesives (DAP, Underfill).\nKCC semiconductor materials are optimized for the processes of world-class semiconductor manufacturers, showing superior performance compared to other companies.\n'
											+'Display materials include UV molding materials and UV sealing materials, and are being sold and promoted to leading domestic and foreign customers with higher quality and advanced technology.',
	user_intro_introAM_body_content2_tit : 'Inorganic materials',
	user_intro_introAM_body_content2_subtxt : 'KCC inorganic materials can be divided into'+'<strong>Metalized Ceramic</strong> and <strong>Ceramic Substrate</strong>.\n\n'
											+'We are developing and supplying Fine Ceramics, a new advanced inorganic material, with our accumulated technology and experience in the field of inorganic materials.\n'
											+'KCC builds an efficient automation process by introducing the latest equipment and advanced technology,\n'
											+"We produce KCC Metalized Ceramics by applying a strict integrated quality management system. \nIn particular, KCC's Ceramic Tube for VI (Vacuum Interrupter) boasts the world's No. 1 market share.\n"
											+'It was selected as a world-class product of 2020 by KOTRA for 12 consecutive years.\n\n'
											+'Ceramic substrate molding (Tape Casting) technology is used to produce ceramic substrate products, the core material of power modules.\nVarious ceramic substrate technologies such as DCB substrates made of alumina (AI2O3) and aluminum nitride (AIN) as raw materials. Has.\n'
											+'According to the recent increase in demand for electric vehicles, the application of HIC substrates to the control unit that finely controls electricity for automobile electronic equipment is being considered.\n'
											+'High reliability substrates such as Si3N4 AMB and ZTA DCB are applied to the power section that outputs electrical output and needs to convert AC and current.',

	user_intro_introAM_body_content3_tit : 'Composite materials',
	user_intro_introAM_body_content3_subtxt : 'Glass long fiber, a composite material of KCC, is mixed with inorganic raw materials such as pyrophyllite and limestone and melted at a high temperature of 1,500℃ or higher.'
											+'<br />It is a product pulled through a small hole in the form of a thin thread in micrometers (one millionth of a meter). <br />General plastics are fragile, weak to heat, and have poor dimensional stability.'
											+'There is a drawback. <br />However, if long glass fibers are applied here, reinforced plastics with high physical strength are reborn. <br />Long glass fiber not only has insulation, but also dimensional stability and strength' +
											+'Because it complements the properties of the back.<br />' +
											+'<br />KCC\'s long glass fibers include Chopped Strand, Chopped Strand Mat, <br />DirectRoving, Conventional' +
											+'Conventional Roving, Woven Roving Tissue, etc. <br />KCC\'s long glass fiber is used not only for the back panel of LCD TVs and monitors, but also for electric/electronic,'
											+'It is widely used across industries such as automobiles and civil construction.',

	// body
	user_intro_introKcc_introSection_addr : '344, Sapyeong-daero, Seocho-gu, Seoul, South Korea',
	user_intro_introKcc_introSection_roundSpan_addr : 'Headquarters',
	user_intro_introKcc_introSection_roundSpan_establish : 'Date of Foundation',
	user_intro_introKcc_introSection_roundSpan_establish_contxt : 'August 12, 1958',
	user_intro_introKcc_introSection_roundSpan_employees : 'Number of employees',
	user_intro_introKcc_introSection_roundSpan_employees_number : 'people',
	user_intro_introKcc_introSection_roundSpan_criteriaAsDate1 : 'As of September 30, 2020',
	user_intro_introKcc_introSection_roundSpan_sales : 'Amt. Sales',
	user_intro_introKcc_introSection_roundSpan_criteriaAsDate2 : 'Year of 2023',
	user_intro_introKcc_introSection_roundSpan_unit : 'million-KRW',

	user_intro_introKcc_detail_tit : 'Business Area',
	user_intro_introKcc_detail_header1_tit : 'Building Materials',
	user_intro_introKcc_detail_header1_contxt1 : 'Ceiling material, insulation material, gypsum board',
	user_intro_introKcc_detail_header2_tit : 'Windows',
	user_intro_introKcc_detail_header2_contxt1 : 'General window, Balcony window, System window',
	user_intro_introKcc_detail_header3_tit : 'Coatings',
	user_intro_introKcc_detail_header3_contxt1 : 'building paints, automotive paints, and ship paints',
	user_intro_introKcc_detail_header3_contxt2 : 'plant paints, industrial paints',
	user_intro_introKcc_detail_header4_tit : 'Advanced Materials',
	user_intro_introKcc_detail_header4_contxt1 : 'Organic materials (EMC), Inorganic materials (AM, DCB)',
	user_intro_introKcc_detail_header4_contxt2 : 'Complex material',

	// NewsRoom
	user_intro_newsroom_header_tit : 'Newsroom',
	user_intro_newsroom_header_subtxt : 'Newsroom description',
	user_intro_newsroom_search_placeholder : 'Search for a title',

	// newroom_view
	user_intro_newsroom_view_relatedProduct : 'Related Product',
	user_intro_newsroom_view_regDate : 'Registration Date',
	user_intro_newsroom_view_hits : 'Views',
	user_intro_newsroom_view_list : 'List',

	// theGlobalNetwork.vue
	user_intro_globalNetwork_header_tit: 'Global Network',
	user_intro_globalNetwork_header_subtxt: 'Global Network details.',

	user_common_nowLoading : 'Loading data...',
	user_common_noData : 'No Data',
	user_common_korea : 'Republic of Korea',
	user_common_japan : 'Japan',
	user_common_china : 'China',
	user_common_veitnam : 'Vietnam',
	user_common_malaysia : 'Malaysia',
	user_common_singapore : 'Singapore',
	user_common_indonesia : 'Indonesia',
	user_common_india : 'India',
	user_common_uae : 'United Arab Emirates',
	user_common_turkey : 'Turkey',
	user_common_germany : 'Germany',
	user_common_uk : 'The United Kingdom',

	// customerSupport_inquery.vue 1:1 문의
	// 상단 배너
	user_customerSupportInquiry_noticeBanner_tit : '1:1 inquiry information',
	user_customerSupportInquiry_noticeBanner_txt1 : 'Contents, abusive language, advertisements, etc. that do not conform to the nature of the bulletin board may be deleted by the administrator without prior notice. ',
	user_customerSupportInquiry_noticeBanner_txt2 : 'Answers to 1:1 inquiries are sent only by e-mail, ',
	user_customerSupportInquiry_noticeBanner_txt3 : 'and please check your ',
	user_customerSupportInquiry_noticeBanner_txt4 : 'personal information processing policy.',

	user_customerSupportInquiry_header_tit : '1:1 Inquiry',
	user_customerSupportInquiry_oneToOne_label : 'Type of inquiry',
	user_customerSupportInquiry_oneToOne_placeholder : 'Choice',
	user_customerSupportInquiry_essential_tit_header : 'Essential',
	user_customerSupportInquiry_essential_tit_subTxt : 'This is a mandatory entry for 1:1 inquiries.',
	user_customerSupportInquiry_essential_email_label : 'E-mail',
	user_customerSupportInquiry_essential_email_placeholder1 : 'Please enter an email.',
	user_customerSupportInquiry_essential_email_placeholder2 : 'Please enter an email server.',
	user_customerSupportInquiry_essential_company_label : 'Corporate name',
	user_customerSupportInquiry_essential_company_placeholder : 'Please enter the company name.',

	user_customerSupportInquiry_elective_tit : 'Optional Input',
	user_customerSupportInquiry_elective_phone_label : 'Cell phone number',
	user_customerSupportInquiry_elective_name_label : 'Name',
	user_customerSupportInquiry_elective_name_placeholder1 : 'Please enter your last name.',
	user_customerSupportInquiry_elective_name_placeholder2 : 'Please enter your first name.',
	user_customerSupportInquiry_elective_department_label : 'Department',
	user_customerSupportInquiry_elective_department_placeholder : 'Please enter the department.',
	user_customerSupportInquiry_elective_tel_label : 'telephone number',
	user_customerSupportInquiry_elective_country_label : 'Country',
	user_customerSupportInquiry_elective_country_placeholder : 'Please enter your country.',
	user_customerSupportInquiry_elective_city_label : 'City',
	user_customerSupportInquiry_elective_city_placeholder : 'Please enter your city.',

	user_customerSupportInquiry_context_tit : 'Inquiry details',
	user_customerSupportInquiry_context_label : 'Question title',
	user_customerSupportInquiry_context_placeholder1 : 'Please enter the title of the inquiry.',
	user_customerSupportInquiry_context_placeholder2 : 'Please enter your inquiry.',

	user_customerSupportInquiry_attach_tit : 'File Attach',
	user_customerSupportInquiry_attach_dropzone_tit : 'Drag and upload the file to upload.',
	user_customerSupportInquiry_attach_dropzone_subtit : '(Or you can click here to select a file to upload from your PC.)',

	user_customerSupportInquiry_swal_inquiry : '1:1 Inquiry',
	user_customerSupportInquiry_swal_inquiry_save : 'Result Of Inquiry Message',
	user_customerSupportInquiry_swal_save_success : 'Save Complete',
	user_customerSupportInquiry_swal_save_error : 'Save failed',
	user_customerSupportInquiry_swal_inquiry_needCategory : 'Please select a 1:1 inquiry type.',
	user_customerSupportInquiry_swal_inquiry_needlQuestion : 'Please fill in the 1:1 inquiry detail question.',
	user_customerSupportInquiry_swal_inquiry_needEssential : 'Missing required input',
	user_customerSupportInquiry_swal_inquiry_needEmail : 'Please fill in the email box.',
	user_customerSupportInquiry_swal_inquiry_needCompany : 'Please fill in the company name box.',
	user_customerSupportInquiry_swal_inquiry_needContext : 'Missing inquiry details',
	user_customerSupportInquiry_swal_inquiry_needTitle : 'Please fill in the title of the inquiry.',
	user_customerSupportInquiry_swal_inquiry_needValidEmail : 'Invalid email address.',

	// customerSupport_contact
	//헤더
	user_customerSupportContact_header_tit : 'Contact',
	//body
	user_customerSupportContact_country_korea : 'Republic of Korea',
	user_customerSupportContact_country_china : 'China',
	user_customerSupportContact_country_japan : 'Japan',

	user_customerSupportContact_country_korea_branch_hq_tit : 'KCC headquarters',
	user_customerSupportContact_country_korea_branch_hq_addr : '344, Sapyeong-daero, Seocho-gu, Seoul',
	user_customerSupportContact_country_china_branch_kunshan_tit : 'KCC (KUNSHAN)',
	user_customerSupportContact_country_china_branch_kunshan_addr : '11F, Shanghai HNA Building,No.898 Puming Road, Shanghai, China',

	user_customerSupportContact_country_china_branch_guangzhou_tit : 'KCC (GUANGZHOU)',
	user_customerSupportContact_country_china_branch_guangzhou_addr : 'Room 3703&3707, ZhongTai International square, NO.161 Linhe West Road, Guangzhou, China',
	user_customerSupportContact_country_japan_branch_yurakucho_tit : 'KCC Japan',
	user_customerSupportContact_country_japan_branch_yurakucho_addr : 'Yurakucho Denki Bldg. South wing 12F, 1-7-1, Yurakucho, Chiyoda-ku, Tokyo, Japan',

	user_customerSupportContact_manager_tit : 'Contact Manager',
	user_customerSupportContact_manager_tel : 'TEL',
	user_customerSupportContact_manager_email : 'EMAIL',

	//#### Market
	//## Market + Function 메인 페이지

	//### 헤더
	user_market_main_header_tit : 'Market',
	user_market_main_header_subtxt : 'KCC\'s advanced materials are applied to realize perfect performance </br> in various industries such as semiconductors, automobiles, electric/electronics/home appliances, architecture, and ships.',
	user_market_list_header_subtxt : 'Market List',
	user_market_view_header_subtxt : 'KCC’s advanced materials are applied to achieve perfect functionalities across a wide range of industries, including semiconductors, automotive, electric, electronic, construction, marine and home applications.'
									+'<br/><br/>KCC is enhancing customers’ future value with cutting-edge materials technology developed through change and innovation.',

	user_market_main_descr1 : 'KCC supplies state-of-the-art materials to various industries such as semiconductors, automobiles, electric/electronics/home appliances, construction, and ships.',
	user_market_main_descr2 : 'KCC is improving the future value of customers through the best high-tech materials through change and innovation.',

	user_market_main_function_tit : 'Function',
	user_market_main_function_descr1 : 'KCC supplies customers with the highest quality products that reflect the various needs of the market.',

	//### 본문
	user_market_main_button_market : 'Go to Market Page',
	user_market_main_button_function : 'Go to Function Page',

	//#### Market 페이지
	//## market View
	//## Related Document
	user_market_relatedDocu_tit : 'Related Document',
	user_market_relatedDocu_docuName : 'Document name',
	user_market_relatedDocu_docuType : 'Document Type',
	user_market_relatedDocu_fileType : 'File type',
	user_market_relatedDocu_download : 'Download',
	user_market_relatedDocu_share : 'Share',
	user_market_references : 'References',

	//market - function 관련
	user_market_function_subtit : 'Funtion List',
	user_market_function_detail_tit : 'KCC provides customers with the highest-quality products, which reflect a broad range of market needs.',

	// 통합검색 (productsupport_integratedSearch)
	integratedSearch_tit : 'Integrated Search',
	integratedSearch_quickLink : 'QuickLink',
	integratedSearch_inputSearch : 'Please enter a search term.',
	integratedSearch_searchResults : 'Total of ',
	integratedSearch_founded : 'casess were searched.',
	integratedSearch_ProductName : 'Product Name',
	integratedSearch_Material : 'Material',
	integratedSearch_Function : 'Function',
	integratedSearch_MarketName : 'Market Name',
	integratedSearch_FunctionName : 'Function Name',

	integratedSearch_ApplicationName : 'Application Name',
	integratedSearch_ApplicationClassification : 'Classification',
	integratedSearch_DetailApplication : 'Detail Application',
	integratedSearch_Product : 'Product',

	// 기술지원 목록표
	integratedSearch_tecSupport_tit : 'Technical support',
	integratedSearch_tecSupport_placeHolder : 'Document search',

	integratedSearch_tecSupport_commonDoc : 'Company common document',
	integratedSearch_tecSupport_introductionDoc : 'Product Introduction document',
	integratedSearch_tecSupport_TQDoc : 'Technology/Quality Document',
	integratedSearch_tecSupport_crDoc : 'Certificate/Report',
	integratedSearch_tecSupport_ptDoc : 'Product training document',

	integratedSearch_tecSupport_fileName : 'File Name',
	integratedSearch_tecSupport_fileType : 'File Type',
	integratedSearch_tecSupport_download : 'Download',
	integratedSearch_tecSupport_share : 'Share',

	//제품지원-제품 카탈로그
	productSupport_productCatalog_tit : 'Product Catalog',
	productSupport_productCatalog_resultTxtAll : 'All Search Results',
	productSupport_productCatalog_resultTxt1 : 'A total of search results ',
	productSupport_productCatalog_resultTxt2 : 'were searched.',
	productSupport_productCatalog_publishedDate : 'published date',

	//confirmSwal
	user_common_confirmSwal_noSearchInput : 'Please enter your search term',
	user_common_confirmSwal_noSearchInput_desc : '',
	user_common_placeHolder_fileName : 'File name search',
	user_common_placeHolder_catalogName : 'Catalog name search',

	//contact
	user_contact_tit : 'Contact',
	user_contact_tel : 'TEL',
	user_contact_addr : 'ADDRESS',
	user_contact_email : 'EMAIL',
	user_contact_businessOffice : 'Business Office',
	user_contact_manager : 'Manager',

	//share modal
	user_shareModal_tit: 'Share technical support documents',
	user_shareModal_inputLabel: 'e-mail',
	user_shareModal_placeHolder: 'Enter your e-mail',
	user_shareModal_btnConfirm: 'Confirm',
	user_shareModal_btnCancel: 'Cancel',
	user_shareModal_confirmSwal_content1: 'Please enter your e-mail address',
	user_shareModal_confirmSwal_content2: 'e-mail format is not correct',

	//문서 다운
	user_docDownload_tit: 'Download the document',

	//글로벌 네트워크 주소==============

	user_globalNetwork_Headquarters_tit : 'Headquarters',
	user_globalNetwork_Headquarters_seoul : 'Seoul Headquarters',
	user_globalNetwork_Headquarters_address : '344 Sapyeong-daero (1301-4 Seocho-dong), Seocho-gu, Seoul, Korea 06608',
	user_globalNetwork_Headquarters_call : '(82)-2-3480-5000',

	user_globalNetwork_CentralResearch_tit : 'Central Research',
	user_globalNetwork_CentralResearch_subtit : 'Central Research',
	user_globalNetwork_CentralResearch_address : '17-5, Mabungro240Beon-gil. Giheung-gu, Yongin-si, Gyeonggi-do, Korea',
	user_globalNetwork_CentralResearch_call : '(82)-31-288-3000',

	user_globalNetwork_Factory_tit : 'Factory',

	user_globalNetwork_Factory_Gapyeong : 'Gapyeong Plant',
	user_globalNetwork_Factory_Gapyeong_production : 'Glass Silica',
	user_globalNetwork_Factory_Gapyeong_address : '2, Muransan-gil, Gapyeong-eup, Gapyeong-gun, Gyeonggi-do, Korea',
	user_globalNetwork_Factory_Gapyeong_call : '(82)-31-580-1500',

	user_globalNetwork_Factory_Gimcheon : 'Gimcheon Plant',
	user_globalNetwork_Factory_Gimcheon_production : 'Cerak Wool',
	user_globalNetwork_Factory_Gimcheon_address : '39, Saneopdanji-ro, Eomo-myeon, Gimcheon-si, Gyeongsangbuk-do, Korea',
	user_globalNetwork_Factory_Gimcheon_call : '(82)-54-420-1700',

	user_globalNetwork_Factory_DaejukGypsumBoard : 'Daejuk Gypsum Board Plant',
	user_globalNetwork_Factory_DaejukGypsumBoard_production : 'Gypsum Board',
	user_globalNetwork_Factory_DaejukGypsumBoard_address : '15, Deajuk 2(i)-ro, Daesan-eup, Seosan-si, Chungcheongnam-do, Korea',
	user_globalNetwork_Factory_DaejukGypsumBoard_call : '(82)-41-660-7000',

	user_globalNetwork_Factory_DaejukSilicone : 'Daejuk Silicone Plant',
	user_globalNetwork_Factory_DaejukSilicone_production : 'Silicone',
	user_globalNetwork_Factory_DaejukSilicone_address : '35, Deajuk 2(i)-ro, Daesan-eup, Seosan-si, Chungcheongnam-do, Korea',
	user_globalNetwork_Factory_DaejukSilicone_call : '(82)-41-660-8700',

	user_globalNetwork_Factory_Munmak : 'Munmak Plant',
	user_globalNetwork_Factory_Munmak_production : 'Glass Wool',
	user_globalNetwork_Factory_Munmak_address : '106, Munmakgongdan-gil, Munmak-eup, Wonju-si, Gangwon-do, Korea',
	user_globalNetwork_Factory_Munmak_call : '(82)-33-749-4500',

	user_globalNetwork_Factory_Sejong : 'Sejong Plant',
	user_globalNetwork_Factory_Sejong_production : 'Fiberglass Continuous Filament',
	user_globalNetwork_Factory_Sejong_address : '40, Sojeonggu-gil, Jeonui-myeon, Sejong Special Self-Governing City, Korea',
	user_globalNetwork_Factory_Sejong_call : '(82)-44-550-5600',

	user_globalNetwork_Factory_Anseong : 'Anseong Plant',
	user_globalNetwork_Factory_Anseong_production : 'Building Coatings / Auto Refinish / Industrial Coatings / Plant Coatings',
	user_globalNetwork_Factory_Anseong_address : '100, Je4sandan-ro, Seoun-myeon, Anseong-si, Gyeonggi-do, Korea',
	user_globalNetwork_Factory_Anseong_call : '(82)-31-670-7777',

	user_globalNetwork_Factory_Asan : 'Asan Plant',
	user_globalNetwork_Factory_Asan_production : 'Flooring / Lami-Film',
	user_globalNetwork_Factory_Asan_address : '658-33, Asan-ro, Yeomchi-eup, Asan-si, Chungcheongnam-do, Korea',
	user_globalNetwork_Factory_Asan_call : '(82)-41-539-9000',

	user_globalNetwork_Factory_Yeocheon : 'Yeocheon Plant',
	user_globalNetwork_Factory_Yeocheon_production : 'Gypsum Board',
	user_globalNetwork_Factory_Yeocheon_address : '830-7 Sangam-ro, Yeosu-si, Jeollanam-do, Korea',
	user_globalNetwork_Factory_Yeocheon_call : '(82)-61-680-7800',

	user_globalNetwork_Factory_Yeoju : 'Yeoju Plant',
	user_globalNetwork_Factory_Yeoju_production : 'Glass',
	user_globalNetwork_Factory_Yeoju_address : '541, Yeojunamro, Ganam-eup, Yeoju-si, Gyeonggi-do, Korea',
	user_globalNetwork_Factory_Yeoju_call : '(82)-31-880-3000',

	user_globalNetwork_Factory_Yeongwol : 'Yeongwol Plant',
	user_globalNetwork_Factory_Yeongwol_production : 'Dolomite / Casmite',
	user_globalNetwork_Factory_Yeongwol_address : 'Wondongjae-ro, Buk-myeon, Yeongwol-gun, Gangwon-do, Korea',
	user_globalNetwork_Factory_Yeongwol_call : '(82)-33-370-1500',

	user_globalNetwork_Factory_Ulsan : 'Ulsan Plant',
	user_globalNetwork_Factory_Ulsan_production : 'Marine Coatings / Plant Coatings / Auto Coatings / Industrial Coatings',
	user_globalNetwork_Factory_Ulsan_address : '30, Bangeojinsunhwan-doro, Dong-gu, Ulsan, Korea',
	user_globalNetwork_Factory_Ulsan_call : '(82)-52-280-1717',

	user_globalNetwork_Factory_JeonjuBuilding : 'Jeonju Building Materials Plant',
	user_globalNetwork_Factory_JeonjuBuilding_production : 'Window Profiles / Metallic Bonding Ceramic',
	user_globalNetwork_Factory_JeonjuBuilding_address : '19, Wanjusandan 4(sa)-ro, Bongdong-eup, Wanju-gun, Jeollabuk-do, Korea',
	user_globalNetwork_Factory_JeonjuBuilding_call : '(82)-63-260-8800',

	user_globalNetwork_Factory_JeonjuPainting : 'Jeonju Painting Plant',
	user_globalNetwork_Factory_JeonjuPainting_production : 'Coatings / Resin / EMC / Powder Coatings',
	user_globalNetwork_Factory_JeonjuPainting_address : '764, Gwahak-ro, Bongdong-eup, Wanju-gun, Jeollabuk-do, Korea',
	user_globalNetwork_Factory_JeonjuPainting_call : '(82)-63-260-7000',

	user_globalNetwork_Factory_JeonjuSilicone : 'Jeonju Silicone Plant',
	user_globalNetwork_Factory_JeonjuSilicone_production : 'Silicone',
	user_globalNetwork_Factory_JeonjuSilicone_address : '801, Gwahak-ro, Bongdong-eup, Wanju-gun, Jeollabuk-do, Korea',
	user_globalNetwork_Factory_JeonjuSilicone_call : '(82)-63-260-1700',

	//영업소
	user_globalNetwork_businessOffice_tit : 'Business Office',

	user_globalNetwork_businessOffice_Seongnam : 'Seongnam Business office',
	user_globalNetwork_businessOffice_Seongnam_address : '210, Daewangpangyo-ro, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea',
	user_globalNetwork_businessOffice_Seongnam_call : '(82)-31-728-6800',

	user_globalNetwork_businessOffice_GyeonggiNorth : 'Northern Gyeonggi Business office',
	user_globalNetwork_businessOffice_GyeonggiNorth_address : '2014, Goyang-daero, Deogyang-gu, Goyang-si, Gyeonggi-do, Republic of Korea',
	user_globalNetwork_businessOffice_GyeonggiNorth_call : '(82)-31-841-0208',

	user_globalNetwork_businessOffice_Namyangju : 'Namyangju Branch office',
	user_globalNetwork_businessOffice_Namyangju_address : '44, Dasanjungang-ro 172beon-gil, Namyangju-si, Gyeonggi-do, Republic of Korea',
	user_globalNetwork_businessOffice_Namyangju_call : '(82)-31-554-4326',

	user_globalNetwork_businessOffice_Suwon : 'Suwon Business office',
	user_globalNetwork_businessOffice_Suwon_address : '472, Gyeongsu-daero, Paldal-gu, Suwon-si, Gyeonggi-do, Republic of Korea',
	user_globalNetwork_businessOffice_Suwon_call : '(82)-31-235-5001',

	user_globalNetwork_businessOffice_Ansan : 'Ansan Branch office',
	user_globalNetwork_businessOffice_Ansan_address : '92, Seonbugwangjang 1-ro, Danwon-gu, Ansan-si, Gyeonggi-do, Republic of Korea',
	user_globalNetwork_businessOffice_Ansan_subAddress : '(Sunbu-dong 1076-21)',
	user_globalNetwork_businessOffice_Ansan_call : '(82)-31-487-7534',

	user_globalNetwork_businessOffice_Hwaseong : 'Hwaseong Branch office',
	user_globalNetwork_businessOffice_Hwaseong_address : '14, Baranmanse-gil, Hyangnam-eup, Hwaseong-si, Gyeonggi-do, Republic of Korea',
	user_globalNetwork_businessOffice_Hwaseong_call : '(82)-31-487-7534',

	user_globalNetwork_businessOffice_Wonju : 'Wonju Business office',
	user_globalNetwork_businessOffice_Wonju_address : '2461, Bugwon-ro, Wonju-si, Gangwon-do, Republic of Korea',
	user_globalNetwork_businessOffice_Wonju_call : '(82)-33-744-6821',

	user_globalNetwork_businessOffice_Gangneung : 'Gangneung Branch office',
	user_globalNetwork_businessOffice_Gangneung_address : '135, Yeonju-ro, Yeongok-myeon, Gangneung-si, Gangwon-do, Republic of Korea',
	user_globalNetwork_businessOffice_Gangneung_call : '(82)-33-662-1705',

	user_globalNetwork_businessOffice_Daejeon : 'Daejeon Business office',
	user_globalNetwork_businessOffice_Daejeon_address : '150, Sintanjin-ro, Daedeok-gu, Daejeon, Republic of Korea',
	user_globalNetwork_businessOffice_Daejeon_call : '(82)-42-635-4323',

	user_globalNetwork_businessOffice_Cheongju : 'Cheongju Business office',
	user_globalNetwork_businessOffice_Cheongju_address : '1130, 2sunhwan-ro, Heungdeok-gu, Cheongju-si, Chungcheongbuk-do, Republic of Korea',
	user_globalNetwork_businessOffice_Cheongju_call : '(82)-43-262-4200',

	user_globalNetwork_businessOffice_Cheonan : 'Cheonan Business office',
	user_globalNetwork_businessOffice_Cheonan_address : '40, Sojeonggu-gil, Jeonui-myeon, Sejong-si, Republic of Korea',
	user_globalNetwork_businessOffice_Cheonan_call : '(82)-44-550-5601',

	user_globalNetwork_businessOffice_Dangjin : 'Dangjin Business office',
	user_globalNetwork_businessOffice_Dangjin_address : '6719, Seohae-ro, Sinpyeong-myeon, Dangjin-si, Chungcheongnam-do, Republic of Korea',
	user_globalNetwork_businessOffice_Dangjin_call : '(82)-41-363-4266',

	user_globalNetwork_businessOffice_Jeonju : 'Jeonju Business office',
	user_globalNetwork_businessOffice_Jeonju_address : '84, Donggok-ro, Deokjin-gu, Jeonju-si, Jeollabuk-do, Republic of Korea',
	user_globalNetwork_businessOffice_Jeonju_call : '(82)-63-211-5300',

	user_globalNetwork_businessOffice_Gwangju : 'Gwangju Business office',
	user_globalNetwork_businessOffice_Gwangju_address : '270, Mujin-daero, Gwangsan-gu, Gwangju, Republic of Korea',
	user_globalNetwork_businessOffice_Gwangju_call : '(82)-62-943-8211',

	user_globalNetwork_businessOffice_Mokpo : 'Mokpo Branch office',
	user_globalNetwork_businessOffice_Mokpo_address : '274, Hugwang-daero, Samhyang-eup, Muan-gun, Jeollanam-do, Republic of Korea',
	user_globalNetwork_businessOffice_Mokpo_subAddress : '(2112 Namak-ri)',
	user_globalNetwork_businessOffice_Mokpo_call : '(82)-61-280-5935',

	user_globalNetwork_businessOffice_Suncheon : 'Suncheon Business office',
	user_globalNetwork_businessOffice_Suncheon_address : '3, Jangseonbaegi-gil, Suncheon-si, Jeollanam-do, Republic of Korea',
	user_globalNetwork_businessOffice_Suncheon_call : '(82)-61-722-7722',

	user_globalNetwork_businessOffice_Daegu : 'Daegu Business office',
	user_globalNetwork_businessOffice_Daegu_address : '111, Taepyeong-ro, Jung-gu, Daegu, Republic of Korea',
	user_globalNetwork_businessOffice_Daegu_call : '(82)-53-252-0227',

	user_globalNetwork_businessOffice_Gumi : 'Gumi Branch office',
	user_globalNetwork_businessOffice_Gumi_address : '103, Cheomdangieop 7-ro, Sandong-eup, Gumi-si, Gyeongsangbuk-do, Republic of Korea',
	user_globalNetwork_businessOffice_Gumi_call : '(82)-54-453-4530',

	user_globalNetwork_businessOffice_Pohang : 'Pohang Business office',
	user_globalNetwork_businessOffice_Pohang_address : '695, Huimang-daero, Nam-gu, Pohang-si, Gyeongsangbuk-do, Republic of Korea',
	user_globalNetwork_businessOffice_Pohang_call : '(82)-54-275-7601',

	user_globalNetwork_businessOffice_Ulsan : 'Ulsan Business office',
	user_globalNetwork_businessOffice_Ulsan_address : '28-17, Jinjangyutong-ro, Buk-gu, Ulsan, Republic of Korea',
	user_globalNetwork_businessOffice_Ulsan_call : '(82)-52-287-0811',

	user_globalNetwork_businessOffice_Busan : 'Busan Business office',
	user_globalNetwork_businessOffice_Busan_address : '1628, Jungang-daero, Geumjeong-gu, Busan, Republic of Korea',
	user_globalNetwork_businessOffice_Busan_call : '(82)-51-580-5200',

	user_globalNetwork_businessOffice_Changwon : 'Changwon Business office',
	user_globalNetwork_businessOffice_Changwon_address : '563, Muyeok-ro, Uichang-gu, Changwon-si, Gyeongsangnam-do, Republic of Korea',
	user_globalNetwork_businessOffice_Changwon_call : '(82)-55-265-3211',

	user_globalNetwork_businessOffice_Jeju : 'Jeju Business office',
	user_globalNetwork_businessOffice_Jeju_address : '340, Yeonsam-ro, Jeju-si, Jeju-do, Republic of Korea',
	user_globalNetwork_businessOffice_Jeju_call : '(82)-64-726-8870',

	//user_main 비주얼 스와이퍼
	user_main_visual01_tit : 'KCC, Your Solution Partner',
	user_main_visual01_descr : 'We provide cutting-edge solutions for the future.',
	user_main_visual02_tit : 'Technology that advances tomorrow with advanced materials',
	user_main_visual02_descr : 'Encapsulant, an insulating material, a core material for semiconductors and electrical and electronic products',
	user_main_visual03_tit : 'We have the technology to shape the future.',
	user_main_visual03_descr : 'Engineering plastic raw material, Fiberglass Continuous Filament',

	//product_main 비주얼 스와이퍼
	product_main_visual_EMC_tit : 'EMC',
	product_main_visual_EMC_descr : 'It can be applied to various semiconductors and has excellent workability, formability and reliability for stable semiconductor performance.',
	product_main_visual_Adhesive_tit : 'Adhesive',
	product_main_visual_Adhesive_descr : 'As an adhesive material for semiconductors, it can be applied to high-performance semiconductors based on excellent workability and reliability.',
	product_main_visual_MetalizedCeramics_tit : 'Metalized Ceramic',
	product_main_visual_MetalizedCeramics_descr : 'Ceramic for VI (Vacuum Interrupter) to which KCC ceramic tube is applied has excellent bonding performance, compactness of structure, and vacuum tightness</br>It is applied to vacuum breakers for transmission and distribution and has been selected as a world-class product for 12 consecutive years.</br> In addition, we are mass-producing and supplying various power tubes and metal bonding ceramic products.',
	product_main_visual_CeramicSubstrates_tit : 'Ceramic Substrate',
	product_main_visual_CeramicSubstrates_descr : 'It is used as a substrate for power module semiconductors by bonding copper to a ceramic substrate using the DCB and AMB methods.</br>It bonds copper to various ceramics and has strength and heat dissipation performance to meet customer needs</br>For automobiles. , industrial and home appliance power module semiconductor substrate.',
	product_main_visual_GlassFiber_tit : 'Glass fiber',
	product_main_visual_GlassFiber_descr : 'It is a glass fiber used to reinforce the properties of engineering plastics.</br>Applicable to various industries such as electric and electronic, home appliances, automobiles, architecture, and ships.</br>Light weight, dimensional stability, low ductility, cold chemical resistance, etc. It provides physical properties that can respond to the needs of each industry.',

	//데이터 시트, 엑셀 다운로드
	datasheet_download : 'Excel Download',
	datasheet_fullScreen : 'Full Screen',
	datasheet_compareProducts : 'Compare Products',
	datasheet_fullList : 'Full List',

	// design rule 다운로드
	design_rule_download : 'Design Rule Download',

	//중국 도시
	globalNetwork_china_Shanghai : 'Shanghai',
	globalNetwork_china_Beijing : 'Beijing',
	globalNetwork_china_Guangzhou : 'Guangzhou',
	globalNetwork_china_Chongqing : 'Chongqing',

	//외부파일
	filetype_externalFile : 'External file',

	// 팝업
	hideToday: 'Don\'t open it today',
	close: 'close',

}
